import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  standalone: false,
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  shareByEmail() {
    window.location.href = `mailto:info@bazar-s.com`;
  }

  openWhatsApp(phoneNumber: string) {
    window.open(`https://wa.me/${phoneNumber}`, '_blank');
  }
}
